var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"app-icon-btn",attrs:{"dark":"","width":"32","color":_vm.color,"disabled":_vm.disabled,"small":_vm.small}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"small":_vm.small}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }